export enum ItemSortType {
  ALL = "전체",
  CATEGORY_ORDER = "카테고리순",
  SALE_STATUS = "판매 여부순",
  DISPLAY_STATUS = "진열 여부순",
}
